import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import omit from 'lodash/omit';
import classNames from 'classnames';
import { pxToRem } from 'choerodon-ui/lib/_util/UnitConvertor';
import TableContext from './TableContext';
import { getColumnLock, isStickySupport } from './utils';
import { ColumnAlign, ColumnLock } from './enum';
const TableFooterCell = function TableFooterCell(props) {
    const { columnGroup, style, className, colSpan, right } = props;
    const { rowHeight, dataSet, prefixCls, tableStore } = useContext(TableContext);
    const { column } = columnGroup;
    const { autoFootHeight, props: { footerRowHeight } } = tableStore;
    const { footer, footerClassName, footerStyle = {}, align, name, command, lock } = column;
    const columnLock = isStickySupport() && tableStore.overflowX && getColumnLock(lock);
    const classString = classNames(`${prefixCls}-cell`, {
        [`${prefixCls}-cell-fix-${columnLock}`]: columnLock,
    }, className, footerClassName);
    const innerClassNames = [`${prefixCls}-cell-inner`];
    const innerProps = {};
    if (footerRowHeight !== 'auto' && rowHeight !== 'auto' && !autoFootHeight) {
        innerProps.style = {
            height: pxToRem(footerRowHeight === undefined ? rowHeight : footerRowHeight),
        };
        innerClassNames.push(`${prefixCls}-cell-inner-row-height-fixed`);
    }
    const cellStyle = {
        textAlign: align || (command ? ColumnAlign.center : tableStore.getConfig('tableColumnAlign')(column, dataSet.getField(name))),
        ...footerStyle,
        ...style,
    };
    if (columnLock) {
        if (columnLock === ColumnLock.left) {
            cellStyle.left = pxToRem(columnGroup.left);
        }
        else if (columnLock === ColumnLock.right) {
            cellStyle.right = pxToRem(colSpan && colSpan > 1 ? right : columnGroup.right + right);
        }
    }
    const getFooter = () => {
        switch (typeof footer) {
            case 'function': {
                const footerHookOptions = {
                    dataSet,
                    name,
                };
                try {
                    return footer(footerHookOptions);
                }
                catch (e) {
                    return footer(dataSet, name);
                }
            }
            case 'string':
                return React.createElement("span", null, footer);
            default:
                return footer;
        }
    };
    return (React.createElement("th", { className: classString, style: omit(cellStyle, ['width', 'height']), colSpan: colSpan, scope: "col" },
        React.createElement("div", Object.assign({}, innerProps, { className: innerClassNames.join(' ') }), getFooter())));
};
TableFooterCell.displayName = 'TableFooterCell';
export default observer(TableFooterCell);
